import React, { FC, HTMLAttributes } from 'react'
import { Box, BoxProps } from '@chakra-ui/core'

export interface Props extends HTMLAttributes<BoxProps> {
  value: number
  size?: String
}

export const DiscountBox: FC<Props> = ({ value, size, ...props }) => {
  return typeof value !== 'undefined' && value > 0 ? (
    <Box
      borderRadius="2px"
      padding="3px 8px 3px 8px"
      bg="secondary.500"
      width="fit-content"
      fontFamily="body"
      fontSize={size === 'big' ? '15px' : '9px'}
      {...props}
    >
      -{value}%
    </Box>
  ) : null
}
